import {
  GroupType,
  ItemFragment,
  ItemType,
  MoreItem,
} from '../graphql/generated/types';
import {initializeFetchStatus} from './initializeFetchStatus.function';
import {initializeParentRelation} from './initializeParentRelation.function';
import {PagewebLayoutState} from './PagewebLayoutState.interface';

/**
 * 주의 : mutable. immer 가 적용된 경우만 사용해야함
 */
export function initializeItemState({
  state,
  id,
  parentId,
  item,
  error,
}: {
  id: string;
  /**
   * groupId
   */
  parentId: string;
  state: PagewebLayoutState;
  item?: ItemFragment;
  error?: Error;
}) {
  const isEnoughData = !!item;
  initializeFetchStatus({
    state,
    id,
    isEnoughData,
    error,
  });

  if (!item) {
    return;
  }

  state.entities.items[id] = item;
  state.relations.groups[parentId].childrenIds.push(id);

  // StandaloneBanner는 특정 해상도에서 우측에 3개의 카드 아이템들과 함께 표현됩니다.
  // 일반적인 Group 내 item들로는 이를 표현할 수 없어 StandaloneBanner와 동일한 section의 카드 중 앞 3개는 SubCard 그룹에 노출되도록 설정하고
  // 해당 SubCard Group을 StandaloneBanner 우측에 노출시켜줍니다.
  if (
    item.type === ItemType.CardView ||
    item.type === ItemType.PosterView ||
    item.type === ItemType.More
  ) {
    const groupParentId = state.relations.groups[parentId].parentId;
    const standaloneBannerAndSubCardGroupId = state.relations.sections[
      groupParentId
    ]?.childrenIds?.find(
      id =>
        state.entities.groups[id].type === GroupType.StandaloneBannerAndSubCard
    );
    if (standaloneBannerAndSubCardGroupId) {
      const [standaloneBannerGroupId, subCardGroupId] =
        state.relations.nestedGroups[standaloneBannerAndSubCardGroupId]
          .childrenIds;
      if (
        subCardGroupId &&
        Object.keys(state.relations.groups[subCardGroupId]).length < 3
      ) {
        const subCardType =
          item.type === ItemType.More
            ? (item as MoreItem).isPosterView
              ? ItemType.PosterView
              : ItemType.CardView
            : item.type;
        state.bannerInfo.subCardType[standaloneBannerGroupId] = subCardType;
      }
    }
  }

  initializeParentRelation({
    state,
    relationKey: 'items',
    id,
    parentId,
  });
  state.relations.items[id] = {parentId};

  if (item.type === ItemType.Banner) {
    if (!state.bannerInfo.selectedBanner[parentId]) {
      state.bannerInfo.selectedBanner[parentId] = id;
    }
  }
}
